module.exports = __webpack_public_path__ + "img/tamara-logo-badge-ar.c6076178.png";